import Header from "./header";
import AdminSidebar from "./admin-sidebar";

interface AdminLayoutProps {
  children: React.ReactNode;
}

/**
 * Admin-mode layout. Same header as the rest of the app, but the primary
 * sidebar is swapped for the admin section navigation. To leave admin
 * mode, use the "Back to App" link at the top of the admin sidebar.
 */
export default function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex">
        <AdminSidebar />
        <main className="flex-1 p-8">{children}</main>
      </div>
    </div>
  );
}
